import React from "react";
import { ShieldCheck, Heart, Leaf, Truck } from "lucide-react";
import about1 from '../assets/about1.png'
import about_kind from '../assets/about_kind.png'
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../common/index"; 
const About = () => {
  const navigate = useNavigate();
  // Helper to handle image errors
 const handleAboutImageClick = async () => {
    try {
      const res = await fetch(SummaryApi.getActiveProduct.url);
      const result = await res.json();
      
      if (result.status && result.data) {
      
        const product = result.data.find(p => {
          const title = p.product_title?.toLowerCase() || "";
          return title.includes("leaf") && title.includes("pads");
        });

        if (product) {
          const encodedId = window.btoa(product.product_id.toString());
          navigate(`/product/${encodedId}`);
        } else {
          // Fallback if specific product isn't found
          navigate('/products');
        }
      }
    } catch (error) {
      console.error("Navigation error:", error);
      navigate('/products');
    }
  };
  const handleImageError = (e) => {
    e.target.src =
      "https://images.unsplash.com/photo-1550581190-9c1c48d21d6c?q=80&w=1000&auto=format&fit=crop"; // Fallback to a safe cotton image
  };

  const values = [
    {
      icon: <ShieldCheck className="w-8 h-8 text-pink-600" />,
      title: "100% Toxin Free",
      description:
        "No chlorine, no fragrances, and no dioxins. Only what your body deserves.",
    },
    // {
    //   icon: <Leaf className="w-8 h-8 text-pink-600" />,
    //   title: "Eco-Conscious",
    //   description:
    //     "Biodegradable layers and recyclable packaging to keep our planet clean.",
    // },
    {
      icon: <Heart className="w-8 h-8 text-pink-600" />,
      title: "Rash-Free Promise",
      description:
        "Feather-soft top sheets designed for the most sensitive skin.",
    },
    {
      icon: <Truck className="w-8 h-8 text-pink-600" />,
      title: "Doorstep Delivery",
      description:
        "Never run out again with our smart, automated subscription plans.",
    },
  ];

  
  return (
    <div className="bg-white text-gray-800 font-sans">
      {/* Section 1: Our Story - Clean Lifestyle Image */}
      <section className="relative py-20 bg-[#FFF5F7]">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-pink-800 mb-6 leading-tight">
             Redefining menstrual care and health care
            </h1>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We started with a simple question: Why should period care be a
              source of discomfort? For too long, the industry ignored the
              rashes, the chemicals, and the environmental waste.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our journey began with a mission to combine{" "}
              <strong>advanced absorbency</strong>. Today, we empower thousands
              of women to own their flow with confidence.
            </p>
          </div>
          <div className="relative">
            <img
              src={about1}
               onClick={handleAboutImageClick}
              alt="Organic Sanitary Pad with Cotton"
              className="rounded-3xl shadow-2xl object-cover h-[450px] w-full border-4 border-white"
              onError={(e) => {
                e.target.src =
                  "https://images.pexels.com/photos/4004460/pexels-photo-4004460.jpeg?auto=compress&cs=tinysrgb&w=1000";
              }}
            />

            {/* <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-xl hidden md:block border border-pink-100">
              <p className="text-pink-600 font-bold text-2xl">50,000+</p>
              <p className="text-sm text-gray-500">Happy Subscribers</p>
            </div> */}
          </div>
        </div>
      </section>

      {/* Section 2: Values Grid */}
      

      {/* Section 3: Sustainability - Nature Image */}
      {/* <section className="py-20 bg-pink-900 text-white overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
          <div className="order-2 md:order-1">
            <img
              src={about_kind}
              alt="Sustainable Living"
              className="rounded-3xl opacity-90 h-[400px] w-full object-cover"
              onError={handleImageError}
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="text-3xl font-bold mb-6">
              Kind to Your Body, Kinder to Earth
            </h2>
            <p className="text-pink-100 text-lg mb-6 leading-relaxed">
              Traditional pads take up to 500 years to decompose. Our pads are
              made with biodegradable materials that return to the earth
              significantly faster.
            </p>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-pink-400 rounded-full"></div>
                <span>Plastic-free top sheet</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-pink-400 rounded-full"></div>
                <span>Sustainable Bamboo Core</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-pink-400 rounded-full"></div>
                <span>FSC Certified paper packaging</span>
              </li>
            </ul>
          </div>
        </div>
      </section> */}

      {/* Section 4: Social Mission */}
      
    </div>
  );
};

export default About;
